var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm._f("年月")(_vm.ym))+"のPDF取込枚数："+_vm._s(_vm.numerator)+"枚／"+_vm._s(_vm.denominator)+"枚")])}
var staticRenderFns = []

export { render, staticRenderFns }